export const DEFAULT_USER_GUIDE_URL =
  'https://mattressfirm.sharepoint.com/sites/TheBEDpost/Information/Pages/CorporatePages/XeHDBpKDVFziBxivUrK0A/8e4b3638-fae0-4d1b-8851-eb1ca5cd917e.aspx'

export const DEFAULT_MERGE_GUIDE_URL = 'https://mfrm.freshservice.com/support/solutions/articles/23000130349'
